module.exports = __webpack_public_path__ + "media/images/partner/upk-basel-4fbdfba399ed98f0ea69e0878ad384f1.png";